import {css} from 'styled-components';

import type {WithThemeProp} from '../../styles';
import type {StyledProps} from './types';

import {getColor, ms} from '../../styles';

const DEFAULT_SIZE = 20;

const getTintColor =
  () =>
  <ComponentProps extends StyledProps & WithThemeProp>(p: ComponentProps) => {
    switch (p.scheme) {
      case 'secondary':
        return getColor('border6')(p);
      default:
        return getColor('border3')(p);
    }
  };

const checked = css`
  border-color: ${getTintColor()};
`;

export const checkedIcon = css<StyledProps>`
  fill: ${getColor('icon2')};
  width: ${p => ms(p.size || DEFAULT_SIZE)};
  height: ${p => ms(p.size || DEFAULT_SIZE)};
  transform: scale(1.3);
`;

export const indeterminateIcon = css<StyledProps>`
  ${checkedIcon};
  transform: scale(1.2);
`;

const base = css<Required<StyledProps>>`
  display: flex;

  /* prevent checkbox from shrinking */
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-color: ${getColor('border2')};
  width: ${p => ms(p.size || DEFAULT_SIZE)};
  height: ${p => ms(p.size || DEFAULT_SIZE)};
  position: relative;
  color: ${getColor('text2')};
  background-color: ${getColor('background1')};
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  ${p => {
    switch (p.variant) {
      case 'circle':
        return css<StyledProps>`
          border-radius: ${ms(p.size || DEFAULT_SIZE)};
          ${p.checked &&
          !p.indeterminate &&
          css<StyledProps>`
            background-color: transparent;
            border-color: ${getTintColor()};
            border-width: ${ms((p.size || DEFAULT_SIZE) / 5)};
          `}
          ${p.indeterminate &&
          css<StyledProps>`
            background-color: ${getTintColor()};
            border-color: ${getTintColor()};
          `}
        `;
      default:
        return css<StyledProps>`
          border-radius: ${ms((p.size || DEFAULT_SIZE) / 5)};
          ${(p.checked || p.indeterminate) &&
          css`
            background-color: ${getTintColor()};
            border-color: ${getTintColor()};
          `}
        `;
    }
  }};
  opacity: ${p => (p.disabled ? 0.5 : 1)};

  ${p => (p.checked ? checked : null)}
`;

export const web = css<StyledProps>`
  box-sizing: border-box;
  ${base}
`;

export const native = css<StyledProps>`
  ${base}
`;
